import { render, staticRenderFns } from "./userlevel.vue?vue&type=template&id=393fba5a&"
import script from "./userlevel.vue?vue&type=script&lang=js&"
export * from "./userlevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports